module.exports = __webpack_public_path__ + "small-logo-white.svg?94c8fa148ff366f38acd8f362227b5a4";